export default __webpack_public_path__ + "static/media/company_bottom_banner.dae6bd1d.png";